<template>
  <div
      ref="root"
      class="row-beat-container tw-flex sm:tw-grid sm:tw-gap-4 sm:tw-space-x-0 tw-grid-flow-col tw-items-center tw-justify-start tw-grid-cols-12 tw-group tw-p-2 tw-border-infinity-background-emphasized tw-border-0 tw-border-b tw-border-solid tw-rounded"
  >
    <div class="tw-col-span-6 md:tw-col-span-4 tw-truncate tw-mr-4 sm:tw-mr-0">
      <div class="tw-flex tw-space-x-3 tw-items-center tw-justify-items-start">
        <div class="tw-w-13 tw-h-13 tw-flex-shrink-0">
          <Artwork class="tw-rounded tw-overflow-hidden" :src="beat.image(imageSize)"
                   :image-size="imageSize">
          </Artwork>
        </div>
        <div class="tw-truncate">
          <span
              class="tw-truncate tw-transition tw-font-bold"
              @click.native.stop
          >{{ item.name }}
          </span>
          <div
              :class="isCurrent ? 'tw-text-infinity-row-active-secondary-text' : 'group-hover:tw-text-infinity-row-hover-secondary-text'"
              class="tw-transition tw-text-infinity-tertiary-text tw-text-xxs tw-font-light">
            {{ itemLabel }}
          </div>
        </div>
      </div>
    </div>
    <div class="tw-col-span-6 md:tw-col-span-8 tw-grid tw-grid-flow-col tw-gap-4 tw-items-center tw-ml-auto sm:tw-ml-0">

      <div class="tw-ml-auto tw-flex-shrink-0 tw-justify-self-end">
        <div class="tw-grid tw-items-center tw-inline-grid tw-grid-flow-col tw-gap-5">
          <!-- Mobile Menu -->
          <button @click="showBeatTapeModal" v-if="this.item.saleable_type === 'collection' || this.item.saleable_type === 'beattapes'" class="c-button c-button--default c-button--shrinked" type="button">
              View beats
          </button>
          <div v-else ref="dropdown" @click.stop>
            <base-popover popover-inner-class="v-popover__inner-no-transform" @click.stop container="#content" placement="bottom-start" :key="beat.id">
              <button class="c-button c-button--default c-button--shrinked"
                      type="button">
                      Download
                <font-awesome-icon class="tw-ml-5"  :icon="['far', 'chevron-down']" />
              </button>
              <div slot="popover">
                <a v-if="downloadLinks.license" :href="downloadLinks.license" target="_blank"
                             v-close-popover
                             class="c-button c-popover-list-item">
                  <span>{{ downloadLicenseLabel }}</span>
                </a>
                <a v-if="downloadLinks.mp3" :href="downloadLinks.mp3" target="_blank"
                             v-close-popover
                             class="c-button c-popover-list-item">
                  <span>Download MP3</span>
                </a>
                <a v-if="downloadLinks.trackout" :href="downloadLinks.trackout" target="_blank"
                             v-close-popover
                             class="c-button c-popover-list-item">
                  <span>Download Trackout</span>
                </a>
                <a v-if="downloadLinks.wav" :href="downloadLinks.wav" target="_blank"
                             v-close-popover
                             class="c-button c-popover-list-item">
                  <span>Download WAV</span>
                </a>
                <a v-if="downloadLinks.sound_packs_zip" :href="downloadLinks.sound_packs_zip" target="_blank"
                             v-close-popover
                             class="c-button c-popover-list-item">
                  <span>Download Sound Pack ZIP</span>
                </a>
              </div>
            </base-popover>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Artwork from "../base/base-artwork";
import PlayButton from "../base/base-play";
import DownloadButton from "../shared/download-button.vue";
import ShareButton from "../shared/share-button.vue";
import BasePopover from "../base/base-popover.vue";
import BuyButton from "../shared/buy-button.vue";

export default {
  props: {
    parent: {
      type: Object,
      default: null
    },
    license: {
      type: Object,
    },
    beat: {
      type: Object,
      required: true
    },
    item: {
      type: Object
    },
    imageSize: {
      type: [Number, String],
      default: 100
    },
    contractDownloadUrl: {
      type: String
    }
  },
  created() {
    // Legacy logic, no idea why :/
    this.$data.$display = "list";
  },
  components: {
    DownloadButton, ShareButton, BasePopover, BuyButton,
    Artwork,
    PlayButton
  },
  data() {
    return {
      isCurrent: false,
    }
  },
  mounted() {
    this.repaint()
  },
  computed: {
    downloadLicenseLabel() {
       return 'Download Contract'
    },
    itemLabel() {
      if(this.license) return this.license.name;
      if(this.item.saleable_type === 'song' ) return 'Song'
      if(this.item.saleable_type === 'beattapes') return 'Beat Tape'
      if(this.item.license_name && this.mediaType) return `${this.item.license_name} - ${this.mediaType}`
      if(this.item.license_name) return this.item.license_name
      return this.mediaType
    },
    mediaType() {
      if(!this.item.saleable_type) return ''
      switch(this.item.saleable_type) {
        case "beat":
          return "Beat"; break;
        case "soundkit":
          return "Sound Pack"; break;
        case "song":
          return "Song"; break;
      }
      return ''
    },
    downloadLinks() {
      return {
        trackout: this.item.trackout_download_url,
        mp3: this.item.saleable_type !== 'soundkit' && this.item.mp3_download_url,
        wav: this.item.wav_download_url,
        sound_packs_zip: this.item.soundkit_download_url,
        license: this.item.saleable_type !== 'song' && this.item.contract_download_url
      }
    },
    isActive() {
      return this.playlistManager.isPlaying(this.beat);
    },
    playerActive() {
      return this.$store.state.player.playing;
    },
    playlistManager() {
      return this.$store.state.playlistManager;
    },
    isPlaying() {
      return this.playlistManager.isPlaying(this.beat) && this.playerActive;
    },
    isPaused() {
      return this.playlistManager.isPlaying(this.beat) && !this.playerActive;
    }
  },
  methods: {
    showBeatTapeModal() {
        const name = this.item.name
        const id = this.item.saleable_id
        this.$modal.show("beat-tape-items", { name: name, id: id })
    },
    repaint() {
      /**
       * There is a bug in iOS 15.5 that cause improper rendering of grid layout,
       * this hack is a workaround for that.
       * */
      this.$nextTick(() => {
        this.$refs.root.style.display = 'none'
        setTimeout(() => {
          this.$nextTick(() => {
            this.$refs.root.style.display = ''
          })
        })
      })
    },
    onClick($event) {
      if (this.$refs.dropdown.contains($event.target)) return;
      this.isCurrent = true;
      if (this.isPlaying) {
        this.beat.pause();
      } else {
        this.beat.play();
      }
    }
  },
  watch: {
    isActive(active) {
      this.isCurrent = active
    }
  }
};
</script>
<style lang="scss" scoped>
.row-beat-container {
  &:last-of-type {
    border-bottom: none;
  }
}
</style>
